<div class="value field" *ngIf="value != null">
    <span class="qa-annual-percentage-rate" translate="annualPercentageRate" [translateParams]="{ apr: this.value | localeNumber: '1.2-2' }"></span>
</div>
